(function() {
	'use strict';
	try {
		if (document.querySelector('.cmp-countdown')) {
			var
				counter = document.querySelector('.cmp-countdown'),
				expiryTime = counter.dataset.expiration,
				countDownDate = new Date(expiryTime).getTime(),
				elDays = counter.querySelector('.days .numbers'),
				elHrs = counter.querySelector('.hrs .numbers'),
				elMins = counter.querySelector('.mins .numbers'),
				elSec = counter.querySelector('.sec .numbers');

			// Update the count down every 1 second
			var x = setInterval(function() {
				var
					now = new Date().getTime(), // Get today's date and time
					distance = countDownDate - now, // Find the distance between now and the count down date
					// Time calculations for days, hours, minutes and seconds
					days = Math.floor(distance / (1000 * 60 * 60 * 24)),
					hrs = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
					mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
					sec = Math.floor((distance % (1000 * 60)) / 1000);

				// Display the result in the counter element
				elDays.innerHTML = days < 10 ? ('0'+days) : days;
				elHrs.innerHTML = hrs < 10 ? ('0'+hrs) : hrs;
				elMins.innerHTML = mins < 10 ? ('0'+mins) : mins;
				elSec.innerHTML = sec < 10 ? ('0'+sec) : sec;

				// If the count down is finished, remove counter
				if (distance < 0) {
					clearInterval(x);
					counter.remove();
				}
			}, 1000);
		}

	} catch (error) {
		// singe data layer error tracking
		if (typeof sdl !== 'undefined') {
			console.error(error);
			sdl.push({
				system: {
					error: {
						type: error.name,
						message: error.message,
					}
				},
				event: 'system.error'
			});
		}
	}
})();
